// Module
var code = ` <template> <div class="page-rules flex-grow-1 animation-page-slide-bottom"> <div class="rules-header"> <h1 class="rules-title">Rules</h1> </div> <partial-tabbed-entity-item steps.bind="steps" view-model.ref="entityItem" on-step-clicked.bind="onStepClicked"></partial-tabbed-entity-item> </div> </template>`;
// Exports
module.exports = code;